import React, { Component } from 'react';
import { connect } from 'react-redux';

export class ContentItem extends Component {
 
  render() {
    return (
      <div className={this.props.position + "-item"}>
        <div className="item__wrap">
          <span className="item-text">{this.props.itemText}</span>
          <span className="item-sub-text">{this.props.itemSubText}</span>
        </div>
        <span className={this.props.cssColorClass + " item-value"}>{this.props.itemValue}</span>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentItem);



// WEBPACK FOOTER //
// ./src/features/scorecard/ContentItem.js